import i18next from "i18next";
import { MdClose } from "react-icons/md";
import { useDesignSystem } from "../context/designSystemContext";

interface ConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  confirmButtonColor?: string;
  isLoading?: boolean;
}

export const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
  confirmText,
  cancelText,
  isLoading = false,
  confirmButtonColor,
}: ConfirmationModalProps) => {
  const { designSystem } = useDesignSystem();

  if (!isOpen) return null;

  const stopPropagation = (e: React.MouseEvent) => {
    e.stopPropagation();
  };

  const handleConfirm = () => {
    onConfirm();
  };

  const defaultConfirmText = i18next.t("yes");
  const defaultCancelText = i18next.t("no");
  const buttonColor =
    confirmButtonColor || designSystem?.cssBasics.secondaryColor;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-15 z-50 grid justify-items-end"
      onClick={onClose}
    >
      <div
        className="fixed top-1/2 right-1/2 bg-white border rounded-xl min-h-fit w-[500px] -translate-y-1/2 translate-x-1/2 z-60 px-5 py-4"
        onClick={stopPropagation}
      >
        {/* Ícone de fechar no canto superior direito */}
        <div className="absolute top-2 right-2">
          <MdClose
            className="cursor-pointer text-red-500"
            size={24}
            onClick={onClose}
          />
        </div>

        {/* Título */}
        <div
          className="font-openSans font-bold text-[16px] leading-[16px] tracking-[0.18px] mb-4 pr-8"
          style={{ color: designSystem?.cssBasics.primaryColor }}
        >
          {title}
        </div>

        {/* Mensagem */}
        <div className="font-openSans text-[14px] text-gray-700 mb-6">
          {message}
        </div>

        {/* Botões */}
        <div className="flex gap-3 justify-end">
          <button
            onClick={onClose}
            disabled={isLoading}
            className="px-4 py-2 rounded-lg font-openSans font-semibold text-gray-700 text-sm border border-gray-300 hover:bg-gray-50 transition-opacity disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {cancelText || defaultCancelText}
          </button>
          <button
            onClick={handleConfirm}
            disabled={isLoading}
            className="px-4 py-2 rounded-lg font-openSans font-semibold text-white text-sm transition-opacity disabled:opacity-50 disabled:cursor-not-allowed"
            style={{
              backgroundColor: buttonColor,
            }}
          >
            {isLoading
              ? i18next.t("loading_configurations")
              : confirmText || defaultConfirmText}
          </button>
        </div>
      </div>
    </div>
  );
};
